import { BaseRoleCodes, RoleCodes } from 'theme/constants';

export const Permissions = {
  CAN_VIEW: Object.values(RoleCodes),
  CAN_EDIT: [
    RoleCodes.SHIP_AGENT_EDITOR_CODE,
    RoleCodes.RELEASE_PARTY_EDITOR_CODE,
    RoleCodes.TERMINAL_EDITOR_CODE,
    RoleCodes.TRANSPORT_OPERATOR_EDITOR_CODE,
  ],
} as const;

export const Permission = {
  CAN_VIEW: 'CAN_VIEW',
  CAN_EDIT: 'CAN_EDIT',
} as const;

export type PermissionKeyType = typeof Permission[keyof typeof Permission];
export type RoleCode = keyof typeof RoleCodes;
export type BaseRoleCode = keyof typeof BaseRoleCodes;
